/**
 * Created by andrej on 3/2/17.
 */
import {doLogout} from '../action-creators/login-actions';

function createThunkMiddleware(extraArgument) {
    return function (_ref) {
        var dispatch = _ref.dispatch;
        var getState = _ref.getState;
        return function (next) {
            return function (action) {
                if (typeof action === 'function') {
                    const result = action(dispatch, getState, extraArgument);
                    if( result['then']) {
                        return result.catch(error=> {
                            if (error.code === 401) {
                                return dispatch(doLogout()).then(() => {
                                    return Promise.reject(error)
                                });
                            }
                            return Promise.reject(error);
                        })
                    }
                    return result;
                }
                return next(action);
            };
        };
    };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

export default thunk;


// WEBPACK FOOTER //
// ./src/model/reducers/thunk-with-logout-middleware.js